import { searchVesselNominations } from "@services/vesselNominationApi";
import { useQuery } from "@tanstack/react-query";

interface UseSearchNominationParams {
  imoNumber?: number;
  enabled?: boolean;
}

export const useSearchNomination = ({ imoNumber, enabled = true }: UseSearchNominationParams) => {
  return useQuery({
    queryKey: ["vesselNominationByImo", imoNumber],
    queryFn: () =>
      searchVesselNominations({
        page: 1,
        pageSize: 100,
        body: {
          vesselImo: [imoNumber as number],
        },
      }),
    enabled: Boolean(imoNumber) && enabled,
  });
};
